module.exports = __webpack_public_path__ + "img/img2.2af5e47c.png";